<!-- 货物属性 -->
<template> 
    <div>
        <el-dialog title="货物属性" :visible.sync="cargoShow" width="60%" :before-close="handleClose" :close-on-click-modal="false">
            <el-checkbox-group v-model="cargoGroup" style="padding-left: 10px;">
                <el-checkbox-button v-for="item in cargoAttributesList" class="checkbox" :label="item" :key="item.codeValue">
                    {{item.codeValue}} - {{ item.codeName }}</el-checkbox-button>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sure">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import AEObasicData from '@/config/AEObasicData.js'
import { String } from 'core-js';

export default {
    props: {
        cargoShow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            cargoGroup:[],
            cargoAttributesList:AEObasicData.cargoAttributesList,
        }
    },
    watch: {
    },
    mounted() { 

    },
    methods: { 
        // 回显值
        cargoChange(value) {
            const codeArray = value.split(',');
            const result = this.cargoAttributesList.filter(item => codeArray.includes(item.codeValue))
            this.cargoGroup = result;
        },
        handleClose() {
            this.$emit('cargoClose',false);
            this.cargoGroup = []
        },
        sure(){
            // 返回选中值
            const codeName = this.cargoGroup.map(item => item.codeName).join(',')
            const codeValue = this.cargoGroup.map(item => item.codeValue).join(',')
            this.$emit('cargoClose',true ,codeName,codeValue);
            this.cargoGroup = []
        }
    }
}
</script>
<style lang="css" scoped>
::v-deep .el-checkbox-button .el-checkbox-button__inner{
    width: 260px;
    border-left: 1px solid #DCDFE6;
    overflow: hidden;
}
</style>